export default "__VITE_ASSET__61f36112__$_?nuxt_component=async&nuxt_component_name=SvgoFreetron__"